import { render, staticRenderFns } from "./SingleRent.vue?vue&type=template&id=06ac2639&scoped=true&"
import script from "./SingleRent.vue?vue&type=script&lang=js&"
export * from "./SingleRent.vue?vue&type=script&lang=js&"
import style0 from "./SingleRent.vue?vue&type=style&index=0&id=06ac2639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac2639",
  null
  
)

export default component.exports